import script from "./ImpersonationPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ImpersonationPanel.vue?vue&type=script&setup=true&lang=js"

import "./ImpersonationPanel.vue?vue&type=style&index=0&id=d68019ee&lang=scss"

const __exports__ = script;

export default __exports__